import styled from 'styled-components';

export const PerformanceVestingStyles = styled.div`
	.container {
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		border-radius: 0.5rem;
		padding: 1rem;
		background: ${({ theme }) => theme.v3.colors.white[0]};
	}
`;
